import axiosInstance from "../config/axiosInstance"

export const dashboardData = async () => {
    const response = await axiosInstance.get('/api/admin/dashboard');
    return response;
}